export const SET_AUTHORS = 'SET_AUTHORS';
export const SET_POSTS   = 'SET_POSTS';
